const get_roles = "/Users/user-roles";
const create_role = "/Users/user-role";
const login_url = "/Users/Login";
const update_profile_image = "/Users/update-profileimage";
const update_password = "/Users/reset-password";
const update_user_status = "/Users/user-status";
const get_user_role_assignment = "/Users/userole-assignments";
const post_user_role_assignment = "/Users/userrole-assignment";
const get_user_role_permissions = "/Users/userrole-permission";
const post_role_permissions = "/Users/role-permissions";
const get_application_list = "/Users/application-list";
const get_users_list = "/Users/users-list";
const get_user_application_contract_list = "/Users/user-contract";
const post_user_application_contract = "/Users/create-contract";
const get_user_associated_role_groups = "/Users/user-rolegroups";
const get_searched_role_groups = "/Users/search-rolegroups";
const post_user_role_groups = "/Users/user-role";
const delete_role = "/Users/role";
const update_role_group_status = "/Users/role-status";
const get_association_types = "/Employee/association-types";
const employee_association = "/Employee/employee-association";
const get_searched_user_list = "/Employee/search-employee-assos";
const get_user_permissions = "/Users/user-permissions";
const process_type = "/bpm/process-type";
const workflow_defs = "/bpm/workflow-defs";
const workflow_actions = "/bpm/workflow-actions";
const workflow_association = "/bpm/workflow-association";
const workflow_association_config_status =
  "/bpm/workflow-association/config-status";
const user_group = "/Users/user-group";
const user_group_membership = "/Users/usergroup-membership";
const status = "/bpm/status";
const status_configuration = "/bpm/status-configuration";
const configure_next_status = "/bpm/configure-nextstatus";
const user_group_association = "/Users/usergroup/association";
const sync_keycloak_users = "/DataSyncher/keycloak/users";
const approval_group = "/Users/approval-group";
const approval_group_association = "/Users/approval-group/association";
const approval_group_to_user_group_association =
  "/Users/approval-group/user-group/association";
const next_available_status = "/bpm/process-status/next-available-status";
export {
  next_available_status,
  approval_group_to_user_group_association,
  approval_group_association,
  approval_group,
  sync_keycloak_users,
  user_group_association,
  configure_next_status,
  status_configuration,
  status,
  user_group_membership,
  user_group,
  workflow_association_config_status,
  workflow_association,
  workflow_actions,
  workflow_defs,
  process_type,
  login_url,
  update_profile_image,
  get_roles,
  create_role,
  update_user_status,
  update_password,
  get_user_role_assignment,
  post_user_role_assignment,
  get_user_role_permissions,
  post_role_permissions,
  get_application_list,
  get_users_list,
  get_user_application_contract_list,
  post_user_application_contract,
  get_user_associated_role_groups,
  get_searched_role_groups,
  post_user_role_groups,
  delete_role,
  update_role_group_status,
  get_association_types,
  employee_association,
  get_searched_user_list,
  get_user_permissions
};
